import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Heart } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Tallahassee Lassie Pet Care</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <div className="min-h-[70vh] flex items-center justify-center py-20">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 text-primary rounded-full mb-8">
          <Heart size={40} />
        </div>
        <h1 className="text-5xl font-serif font-bold text-foreground mb-4">Oops!</h1>
        <p className="text-xl text-muted-foreground mb-8">
          Looks like this page wandered off the leash. Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button asChild size="lg" className="h-14 px-8 text-lg">
            <Link href="/">
              Back to Home
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="h-14 px-8 text-lg border-2">
            <Link href="/contact-us">
              Contact Us
            </Link>
          </Button>
        </div>
      </div>
    </div>
    </>
  );
}
